import { takeLeading, put, all, call } from 'redux-saga/effects';

import axios from 'axios';

import { getTermDataSuccess, getTermDataFailure } from './termination.actions';

import TerminationActionTypes from './termination.types';

export function* getTerminationData() {
  try {
    const response = yield call(axios, {
      url: process.env.REACT_APP_LOCAL_URL + '/newhire/data',
      method: 'get',
    });

    if (response.data.status === 'success') {
      yield put(getTermDataSuccess(response.data.data));
    } else {
      alert('Error getting TerminationData ');
    }
  } catch (error) {
    alert('Error on server while getting Termination Data');
    yield put(getTermDataFailure(error));
  }
}

export function* onGetTerminationData() {
  yield takeLeading(
    TerminationActionTypes.GET_TERM_DATA_START,
    getTerminationData
  );
}

export function* terminationSagas() {
  yield all([call(onGetTerminationData)]);
}
